module.exports = __WEBPACK_EXTERNAL_MODULE_31__;


//////////////////
// WEBPACK FOOTER
// external "isogd-file-rest"
// module id = 31
// module chunks = 0